import { NetworkError } from './NetworkError';
import { FetchErrorName } from './types';

/**
 * This is a specific error that should be thrown when session expiration is determined during a fetch operation.
 */
export class UnauthorizedError extends NetworkError {
  public name = FetchErrorName.UnauthorizedError;

  public constructor(message: string, endpoint?: string, url?: string) {
    super(message, undefined, endpoint, url);
    Object.setPrototypeOf(this, UnauthorizedError.prototype);
  }
}
